import { apiClient } from '../utils/api-client';
import type {
  AssetTransaction,
  AssetTransactionApproveRequest,
  AssetTransactionCancelRequest,
  AssetTransactionCreateRequest,
  AssetTransactionCreateResponse,
  AssetTransactionPageResult,
  AssetTransactionUpdateRequest,
} from '../types/assetTransaction';
import type { CaptableGLTransaction } from '../types/captable';

export const assetTransactionService = {
  async getById(id: string): Promise<AssetTransaction> {
    return apiClient.get<AssetTransaction>(`/asset-transactions/${id}`);
  },

  async list(portfolioCompanyId: string): Promise<AssetTransactionPageResult> {
    return apiClient.get<AssetTransactionPageResult>(
      `/asset-transactions?portfolio_company_id=${portfolioCompanyId}&page_size=100`
    );
  },

  async create(
    data: AssetTransactionCreateRequest
  ): Promise<AssetTransactionCreateResponse> {
    return apiClient.post<AssetTransactionCreateResponse>(
      '/asset-transactions',
      data
    );
  },

  async update(
    id: string,
    data: AssetTransactionUpdateRequest
  ): Promise<AssetTransactionCreateResponse> {
    return apiClient.put<AssetTransactionCreateResponse>(
      `/asset-transactions/${id}`,
      data
    );
  },

  async approve(
    transactionId: string,
    data: AssetTransactionApproveRequest
  ): Promise<AssetTransactionCreateResponse> {
    return apiClient.post<AssetTransactionCreateResponse>(
      `/asset-transactions/${transactionId}/approve`,
      data
    );
  },

  async cancel(
    transactionId: string,
    data: AssetTransactionCancelRequest
  ): Promise<AssetTransactionCreateResponse> {
    return apiClient.post<AssetTransactionCreateResponse>(
      `/asset-transactions/${transactionId}/cancel`,
      data
    );
  },

  async delete(id: string): Promise<void> {
    return apiClient.delete(`/asset-transactions/${id}`);
  },

  async getJournalEntries(
    transactionId: string
  ): Promise<CaptableGLTransaction[]> {
    return apiClient.get<CaptableGLTransaction[]>(
      `/asset-transactions/${transactionId}/journal-entries`
    );
  },
};
